import React, { useState } from 'react';
import './Style.scss';

import logo from '../../../../assets/img/IconosAppGIAMovil/logo.svg';
import { IPropsScreen } from '../Domain/IPropsScreen';

interface IComponentPassword extends IPropsScreen {
    name: keyof IPropsScreen["form"]["values"];
    label: string;
}

const ComponentPassword = (props: IComponentPassword) => {
    const [showPassword, setShowPassword] = useState(true);
    return (
        <div className="col-12 pt-3">
            <label className="fw-semibold">{props.label}</label>
            <div className="input-group input-group-lg">
                <span className="input-group-text" >
                    <i className="fa-solid fa-key" />
                </span>
                <input
                    type={showPassword ? 'password' : 'text'}
                    name={props.name}
                    className="form-control"
                    placeholder={props.label}
                    value={props.form.values[props.name]}
                    onChange={(evt) => props.onChange(props.name, evt.target.value)}
                    required
                />
                <button className="btn btn-primary addon-button-primary" type="button" onClick={() => setShowPassword(!showPassword)}><i className={`fa-solid fa-eye${showPassword ? '-slash' : ''}`} /></button>
            </div>
        </div>
    )
}

export const ViewMain = (props: IPropsScreen) => {

    return (
        <div className="ViewChangePassword">
            <div className="fondo"></div>
            <div className="login-block">
                {/* <div className="container"> */}
                <div className="row text-center">
                    <div className="col-12 d-flex flex-column align-items-center">
                        <img src={logo} alt="logo.png" width={80} />
                        <span className='fw-bold mt-2' style={{ fontSize: 16 }}>Gestor Integral de Administración</span>
                    </div>
                </div>
                <div className='card p-3 shadow-sm mt-5 rounded-5'>

                    {/*                 MENSAJE DE OBLIGATORIEDAD                */}
                    <div className="alert alert-warning mb-0" role="alert" style={{ textAlign: 'justify' }} dangerouslySetInnerHTML={{ __html: props.user.MessageObligate }}/>

                    <form noValidate onSubmit={(evt) => props.onSubmit(evt as any)}>
                        <div className="row">
                            
                            <ComponentPassword
                                {...props}
                                label='Contraseña Actual'
                                name='currentPassword'
                            />

                            <ComponentPassword
                                {...props}
                                label='Nueva Contraseña'
                                name='newPassword'
                            />

                            <ComponentPassword
                                {...props}
                                label='Confirmar Contraseña'
                                name='repeatPassword'
                            />

                        </div>

                        <div className="row" style={{ marginTop: 28 }}>
                            <div className="col-12">
                                <button type="submit" className="btn btn-primary" style={{ width: '100%', backgroundColor: '#01397D' }}>
                                    Actualizar contraseña
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
                
                
            </div>
            <div className='login-block fw-semibold d-flex justify-content-end align-items-end' style={{top:'95%'}}>
                <span className="text-primary">Idioma:</span><span>Español</span>
            </div> 
        </div >
    )
};